export const timestamp = () => new Date().toISOString().replace('T', ' ').slice(0, -1) + '000'
